import type { CheckoutLine, CheckoutLink } from "./checkout";
import type { CheckoutProduct } from "./variants";

export interface MarketplaceProductGroup {
  id: string;
  name: string;
  products: CheckoutProduct[];
  cartRowCount: number;
}

/** Group products by fulfillment brand and sort by active cart rows, keeping ties stable. */
export function groupMarketplaceProducts(
  link: CheckoutLink,
  lines: CheckoutLine[],
): MarketplaceProductGroup[] {
  const groups = new Map<string, MarketplaceProductGroup>();

  for (const product of link.products) {
    const id = product.fulfillment_brand_id || product.retailer_id || "other";
    const name = product.fulfillment_brand_name || product.retailer_name || "Other items";
    const group = groups.get(id) ?? { id, name, products: [], cartRowCount: 0 };
    group.products.push(product);
    group.cartRowCount += lines.filter((line) => line.productId === product.id && line.quantity > 0).length;
    groups.set(id, group);
  }

  return [...groups.values()].sort((a, b) => b.cartRowCount - a.cartRowCount);
}
